module.exports = __webpack_public_path__ + "media/stylesheets/images/lp/review-avatar-ad32c9f4e19e6d0734c08bf7d7daa413.png";